@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconsWrapper {
  position: relative;
  width: 24px;
  height: 24px;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  animation: fade 0.2s ease-in-out;
}
